import { isDebugSurface } from '../../../shared/diagnostics/isDebugSurface';
import { storage } from '../../services/StorageService';
import { bootParam, updateBootSearchParams } from '../../../config/boot/bootUrl';

/**
 * One source of truth for every freeze-detail control (card, HUD widget,
 * launcher, and Settings). URL flags remain the highest-priority session
 * override; diagnostic surfaces default on until the operator explicitly
 * chooses OFF.
 */
export function readFreezePopupEnabled(): boolean {
  if (typeof window !== 'undefined') {
    const override = bootParam('freezePopup');
    if (override === '1') return true;
    if (override === '0') return false;
  }
  if (isDebugSurface()) return true;
  return storage.loadUserPrefs().dev.persistentFreezePopup;
}

export function writeFreezePopupEnabled(enabled: boolean): void {
  if (typeof window !== 'undefined') {
    const keepExplicitOff = !enabled && isDebugSurface();
    // /debug normally forces detail cards on. Preserve an explicit OFF in the
    // URL there so the diagnostic default cannot undo the operator's click.
    // bootUrl keeps this right after the main-domain address-bar clean too.
    updateBootSearchParams((params) => {
      if (keepExplicitOff) params.set('freezePopup', '0');
      else params.delete('freezePopup');
    });
  }

  const current = storage.loadUserPrefs();
  storage.saveUserPrefs({
    ...current,
    dev: { ...current.dev, persistentFreezePopup: enabled },
  });
}
